import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import NameSettings from '@routes/Home/routes/AdminPortal/routes/OrganizationSettings/routes/NameSettings';
import WeekSettings from '@routes/Home/routes/AdminPortal/routes/OrganizationSettings/routes/WeekSettings';
import ProgressReportsSettings from '@routes/Home/routes/AdminPortal/routes/OrganizationSettings/routes/ProgressReportsSettings';

const OrganizationSettingsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'OrganizationSettings' */ './components/OrganizationSettings'
		)
);

export default (store) => {
	return {
		path: 'organization-settings',
		element: (
			<AsyncLoading
				component={
					<OrganizationSettingsLazy permission="CanViewOrganizationSettings" />
				}
			/>
		),
		children: [
			NameSettings(store),
			WeekSettings(store),
			ProgressReportsSettings(store),
		],
	};
};
